import { fetchApi } from '@/config/axiosSetting';
import { DeleteBodyWagesParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/deleteBodyWages/deleteBodyWagesQuery.type';

export const deleteBodyWagesQueryFunction = (
  params: DeleteBodyWagesParamsType,
) =>
  fetchApi.delete(
    `body/reports/${params?.id}/accident_users/damaged/adjusting/wages/`,
    {
      params,
    },
  );
